import React, { useRef } from 'react';
import  {Tooltip, Button, Dialog, Classes}  from "@blueprintjs/core";
import Endpoints from "../../endpoints.js";
import TypificationSelect from './typification_select/typification_select.js'; // Ajusta la ruta según la ubicación real del componente


function ArchiveDialog(props) {
    let categorySelect = useRef(null);

    const archiveConversation = (e) => {
        e.preventDefault()

        if(window.confirm("¿Estás seguro de liberar esta conversación?")) {
            props.closeArchiveDialog()
            const body = {
                WaId: props.currentConversation,
                Category: parseInt(categorySelect.current.value)
            }

            fetch(Endpoints().GCP_ARCHIVE_MESSAGE_URL, {
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+ props.currentAgent.stsTokenManager.accessToken
              },
              method: "POST"
            })

            //window.location = "/#";
            props.hideConversation(props.currentConversation)
        }
    }

    return (
        <Dialog
            icon="archive"
            onClose={props.closeArchiveDialog}
            title='Liberar conversación'
            isOpen= {props.archiveDialogIsOpen}>
            <form onSubmit={archiveConversation}>
              <div className={Classes.DIALOG_BODY}>
                <label>
                  Categoría
                </label>
                <div className="form-group">
                <TypificationSelect typification={props.typification} typificationRef={categorySelect} />

                  {/* <select className="form-control form-control-sm" name="conversationCategory" required={true} defaultValue="" ref={categorySelect}>
                    <option value="">Selecciona una categoría</option>
                    <optgroup label="General">
                      <option value="20">Cliente dejó de contestar</option>
                      <option value="30">Conversación expiró</option>
                      <option value="40">Se atendió solicitud por este medio</option>
                      <option value="50">Se atendió solicitud por otro medio</option>
                      <option value="60">Conversación concluida</option>
                    </optgroup>
                    <optgroup label="Interesado">
                      <option value="100">Prospecto interesado, se agenda cita en sucursal</option>
                      <option value="101">Prospecto interesado, se agenda cita a domicilio</option>
                    </optgroup>
                    <optgroup label="Convertido">
                      <option value="150">Venta cerrada ganada por OBD</option>
                    </optgroup>
                      <optgroup label="Descartado">
                        <option value="120">Se envió mensaje inicial pero no contesta</option>
                        <option value="130">Prospecto interactuó pero dejó de contestar</option>
                        <option value="131">Prospecto interactuó y dijo que lo va a pensar</option>
                        <option value="133">Prospecto interactuó y no era lo que esperaba</option>
                        <option value="122">Prospecto interactuó y no le gustó la forma de contratación</option>
                        <option value="123">Prospecto interactuó y no cuenta con documentación requerida</option>
                        <option value="126">Prospecto interactuó y tiene mal buro</option>
                        <option value="127">Prospecto interactuó y no cumple con los ingresos requeridos</option>
                        <option value="128">Prospecto interactuó y comenta que ya acudió a sucursal</option>
                        <option value="134">Prospecto interactuó y comenta que él va a ir por su cuenta</option>
                        <option value="135">Prospecto interactuó y solo desea información</option>
                        <option value="136">Prospecto solicita apoyo CASA </option>
                        <option value="137">Persona menciona que es publicidad engañosa o no clara</option>
                        <option value="138">Prospecto expresa abiertamente que no está interesado</option>
                        <option value="139">Prospecto solicita apoyo Sucursal</option>
                      </optgroup>
                  </select> */}
                </div>
              </div>
              <div className={Classes.DIALOG_FOOTER}>
                  <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                      <Tooltip content="Cierra el recuadro sin liberar.">
                          <Button onClick={props.closeArchiveDialog}>Cancelar</Button>
                      </Tooltip>
                      <Tooltip content="Libera y desaparece la conversación actual.">
                          <Button type="submit" className="bp3-intent-primary">Liberar</Button>
                      </Tooltip>
                  </div>
              </div>
            </form>
        </Dialog>
    )
}

export default ArchiveDialog;
